// src/components/PageLoader.tsx
import React from "react";
import { Box, Center, Flex, Spinner, Text, VStack, useColorModeValue } from "@chakra-ui/react";
// trigger frontend build
const PageLoader: React.FC = () => {
  const bg = useColorModeValue("white", "gray.900");
  
  return (
    <Flex
      data-testid="page-loader"
      w="100%"
      h="100vh"
      alignItems="center"
      justifyContent="center"
      bg={bg}
    >
      <VStack spacing={6}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor={useColorModeValue("gray.200", "gray.700")}
          color={useColorModeValue("blue.500", "blue.400")}
          size="xl"
        />
        <Text
          fontSize="lg"
          fontWeight="medium"
          color={useColorModeValue("gray.600", "gray.400")}
          letterSpacing="wide"
        >
          Loading...
        </Text>
      </VStack>
    </Flex>
  );
};

export default PageLoader;
